<template>
    <div v-if="sizes.length > 0">
        <div v-if="showLabel">
            {{ __('Méret') }}:
        </div>

        <div class="toolbar toolbar-inline toolbar-size">
            <div v-for="size in sizes" :key="size.id" :disabled="size.quantity <= 0"
                 class="button"
                 :class="{'selected': (selectedSize ? selectedSize.id : null) === size.id, 'disabled': size.quantity <= 0}"
                 @click="$emit('update:selectedSize', size);">
                <label>
                    <input
                        type="radio"
                        :id="size.id"
                        :value="size.id"
                        :disabled="size.quantity <= 0">
                    <span>{{ size.name }}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SizeSelector',

    props: {
        sizes: {
            type: Array,
        },

        selectedSize: {
            type: Object,
        },

        showLabel: {
            type: Boolean,
            default: () => true,
        },
    },
}
</script>

<style scoped>

</style>
